import React from 'react';
import { BrowserRouter as Router,  Route, Routes,Navigate } from 'react-router-dom';
//import HomePage from './HomePage';
import LemmaPage from './LemmaPage';
import CmnLemmaPage from './CmnLemmaPage';
import NotFoundPage from './NotFoundPage'; // Import your PrivacyPolicy component
import UserDashboard from './user/UserDashboard';
import UserLogout from './user/UserLogout';
import DashLogin from './user/UserDashLogin'
import DashSignup from './user/UserDashSignup';
import LemmaProgress from './LemmaProgress'
import CmnLemmaProgress from './CmnLemmaProgress'
import CmnBookPage from './CmnBookPage';
import CmnPhrasePage from './CmnPhrasePage';
import FreLemmaPage from './FreLemmaPage'
import FreLemmaProgress from './FreLemmaProgress'

function App2() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LemmaPage />} /> 
        <Route path="/lemma/*" element={<LemmaPage />} />
        <Route path="/cmnlemma/*" element={<CmnLemmaPage />} />
        <Route path="/login" element={<DashLogin />} />
        <Route path="/signup" element={<DashSignup />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/logout" element={<UserLogout />} />
        <Route path="/progress/*" element={<LemmaProgress />} />
        <Route path="/cmnprogress/*" element={<CmnLemmaProgress />} />
        <Route path="/cmnbook/*" element={<CmnBookPage />} />
        <Route path="/cmnphrase/*" element={<CmnPhrasePage />} />
        <Route path="/frelemma/*" element={<FreLemmaPage />} />
        <Route path="/freprogress/*" element={<FreLemmaProgress />} />
        <Route path="*"  element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}
export default App2;
